import { isCurrentBeneficiaryEntityKind } from '@/modules/entities/EntityBeneficiariesSubform/EntityBeneficiariesSubform.constants';
import { EntityKind } from '@/types/schema';

export function getBeneficiariesGroupHeading({
  heading: externalHeading,
  entityKind,
}: {
  heading?: string;
  entityKind?: EntityKind | undefined | null;
}) {
  if (externalHeading) {
    return externalHeading;
  }

  if (!entityKind) {
    return 'Beneficiaries';
  }

  if (isCurrentBeneficiaryEntityKind(entityKind)) {
    return 'Current beneficiaries';
  }

  if ([EntityKind.GratTrust, EntityKind.QprtTrust].includes(entityKind)) {
    return 'Remainder beneficiaries';
  }

  return 'Beneficiaries';
}
